<template>
  <div>
    <img id="nerd-image" src="/static/images/nerd/nerd1.jpg" @click="imageClicked()">
  </div>
</template>

<script>
export default {
  data () {
    return {
      nerdSound: null,
      nerdImages: [],
      nerdImageIndex: 1,
      nerdImageIndexIncrease: true,
      nerdImageDelay: 2,
      nerdImageDelayIndex: 0
    }
  },
  methods: {
    nerdTalk () {
      this.nerdImageDelayIndex++

      if (this.nerdImageDelayIndex === this.nerdImageDelay) {
        this.nerdImageDelayIndex = 0
      } else {
        window.requestAnimationFrame(this.nerdTalk)
        return
      }

      var el = document.getElementById('nerd-image')

      if (this.nerdImageIndexIncrease) {
        this.nerdImageIndex++

        if (this.nerdImageIndex === 4) {
          this.nerdImageIndex = 2
          this.nerdImageIndexIncrease = false
        }
      } else {
        this.nerdImageIndex--

        if (this.nerdImageIndex === -1) {
          this.nerdImageIndex = 1
          this.nerdImageIndexIncrease = true
        }
      }

      el.src = this.nerdImages[this.nerdImageIndex].src
      if (!this.nerdSound.paused) {
        window.requestAnimationFrame(this.nerdTalk)
      } else {
        el.src = this.nerdImages[0].src
      }
    },
    imageClicked () {
      if (this.nerdSound.paused) {
        this.nerdSound.play()
        window.requestAnimationFrame(this.nerdTalk())
      }
    },
    preloadImage (src) {
      let temp = new Image()
      temp.src = src
      this.nerdImages.push(temp)
    }
  },
  created () {
    this.nerdImageElement = document.getElementById('nerd-image')
    this.nerdImages = []
    this.nerdSound = new Audio('/static/audio/nerd.mp3')

    this.preloadImage('/static/images/nerd/nerd1.jpg')
    this.preloadImage('/static/images/nerd/nerd2.jpg')
    this.preloadImage('/static/images/nerd/nerd3.jpg')
    this.preloadImage('/static/images/nerd/nerd4.jpg')
  }
}
</script>

<style lang="scss" scoped>
  #html {
    background: linear-gradient(270deg, #12ecb4, #8112ec, #23ff00, #d7ff00, #ff0000, #0600ff);
    background-size: 1200% 1200%;
    animation: AnimationName 20s infinite;
  }

  @keyframes AnimationName {
    0% {
      background-position:0% 50%
    }
    50% {
      background-position:100% 50%
    }
    100% {
      background-position:0% 50%
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fun/Nerd.vue